import { createContext, useContext, useState } from "react";
import { event } from "src/lib/ga";

const AppContext = createContext();
const LIVESTREAM_URL = `${
  process.env.NEXT_PUBLIC_BASE_URL || "https://kvrx.org"
}/now_playing/stream`;

const PlayerStateProvider = ({ children }) => {
  const [playerState, setPlayerState] = useState({
    isListeningToShowRecording: false,
    isLoading: false,
    isPlaying: false,
    playbackError: null,
    volume: 1,
    src: LIVESTREAM_URL,
  });

  const toggleLivestream = () => {
    setPlayerState((state) => {
      const isPlaying = !state.isPlaying;
      if (isPlaying) event({ category: "Livestream", action: "play" });
      else event({ category: "Livestream", action: "pause" });

      return {
        ...state,
        isPlaying: !state.isPlaying,
        isLoading: !state.isPlaying,
        playbackError: null,
      };
    });
  };
  const setLoading = (status) => {
    setPlayerState((state) => ({ ...state, isLoading: status }));
  };
  const setPlaybackError = () => {
    setPlayerState((state) => ({
      ...state,
      isLoading: false,
      isPlaying: false,
      playbackError: "The live stream is not available right now.",
    }));
  };
  const listenToRecording = (src) => {
    setPlayerState((state) => ({
      ...state,
      src: src,
      isListeningToShowRecording: true,
      isPlaying: true,
      playbackError: null,
    }));
  };
  const listenToLivestream = () => {
    setPlayerState((state) => ({
      ...state,
      src: LIVESTREAM_URL,
      isListeningToShowRecording: false,
      isPlaying: true,
      playbackError: null,
    }));
  };
  const adjustVolume = (volume) => {
    setPlayerState((state) => ({
      ...state,
      volume: volume,
    }));
  };

  const contextProps = {
    ...playerState,
    toggleLivestream,
    setLoading,
    setPlaybackError,
    listenToRecording,
    listenToLivestream,
    adjustVolume,
  };

  return (
    <AppContext.Provider value={contextProps}>{children}</AppContext.Provider>
  );
};

function usePlayerState() {
  return useContext(AppContext);
}

export { usePlayerState };

export default PlayerStateProvider;
